import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
      // $('.tb-preloader-wave').fadeOut();
      // $('#tb-preloader').delay(200).fadeOut('slow').remove();
  }

}



// WEBPACK FOOTER //
// /var/www/html/oneills-web-qa/src/app/footer/footer.component.ts